import { Link } from 'react-router-dom';
import { topRatedMovies, mostViewedMovies } from '@/mocks/movies';

export default function RankingSection() {
  return (
    <section className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
      <div className="rounded-xl bg-background-100/60 p-5 md:p-6">
        <div className="flex items-center justify-between mb-5">
          <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-100 flex items-center gap-2">
            <i className="ri-trophy-line text-accent-500 text-xl" />
            评分排行榜
          </h2>
          <Link to="/category/all" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
            查看全部 <i className="ri-arrow-right-line" />
          </Link>
        </div>
        <div className="flex flex-col gap-1">
          {topRatedMovies.map((movie, idx) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="flex items-center gap-4 p-3 rounded-lg hover:bg-background-200/60 transition-colors group cursor-pointer"
            >
              <span className={`w-7 h-7 flex items-center justify-center rounded-full text-xs font-bold flex-shrink-0 ${
                idx < 3
                  ? 'bg-accent-500 text-background-950'
                  : 'bg-background-300/50 text-foreground-400'
              }`}>
                {idx + 1}
              </span>
              <div className="w-12 h-16 flex-shrink-0 rounded-md overflow-hidden">
                <img src={movie.poster} alt={movie.title} className="w-full h-full object-cover" />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="font-heading text-sm font-semibold text-foreground-100 group-hover:text-primary-400 transition-colors truncate">
                  {movie.title}
                </h4>
                <p className="text-xs text-foreground-400 mt-0.5">{movie.year} · {movie.category}</p>
              </div>
              <div className="flex items-center gap-1 flex-shrink-0">
                <i className="ri-star-fill text-accent-500 text-xs" />
                <span className="text-sm font-semibold text-accent-400">{movie.rating}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>

      <div className="rounded-xl bg-background-100/60 p-5 md:p-6">
        <div className="flex items-center justify-between mb-5">
          <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-100 flex items-center gap-2">
            <i className="ri-fire-line text-primary-500 text-xl" />
            热播排行榜
          </h2>
          <Link to="/category/all" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
            查看全部 <i className="ri-arrow-right-line" />
          </Link>
        </div>
        <div className="flex flex-col gap-1">
          {mostViewedMovies.map((movie, idx) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="flex items-center gap-4 p-3 rounded-lg hover:bg-background-200/60 transition-colors group cursor-pointer"
            >
              <span className={`w-7 h-7 flex items-center justify-center rounded-full text-xs font-bold flex-shrink-0 ${
                idx < 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-300/50 text-foreground-400'
              }`}>
                {idx + 1}
              </span>
              <div className="w-12 h-16 flex-shrink-0 rounded-md overflow-hidden">
                <img src={movie.poster} alt={movie.title} className="w-full h-full object-cover" />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="font-heading text-sm font-semibold text-foreground-100 group-hover:text-primary-400 transition-colors truncate">
                  {movie.title}
                </h4>
                <p className="text-xs text-foreground-400 mt-0.5">{movie.year} · {movie.category}</p>
              </div>
              <div className="flex items-center gap-1 flex-shrink-0 text-xs text-foreground-400">
                <i className="ri-eye-line" />
                <span>{(movie.viewCount / 10000).toFixed(0)}万</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}